// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vertical-navigation {
  position: fixed;
  display: flex;
  flex-direction: column;
  height: calc(100% - 80px);
  top: 80px;
  background-color: var(--gray-20);
  width: 118px;
  text-align: center;
  align-items: center;
  font-size: var(--inter-body-1-medium-size);
  color: var(--gray-100);
  padding-top: 40px;
  

}

.vertical-navigation-first-button,
.vertical-navigation-second-button,
.vertical-navigation-third-button,
.vertical-navigation-fourth-button,
.vertical-navigation-fifth-button,
.vertical-navigation-sixth-button,
.vertical-navigation-seventh-button,
.vertical-navigation-eigth-button,
.vertical-navigation-settings-button,
.vertical-navigation-contact-button,
.vertical-navigation-profile-button {
  position: relative;
  width: 100%;
  cursor: pointer;
  border: none;
  padding: 0;
  background-color: transparent;
  margin-bottom: 30px;
  
  /* TEXT FONT */
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  letter-spacing: 0.12px;
}


.vertical-navigation-pictures1 {
  position: relative;
  height: calc(100% - 35px);
  width: calc(100% - 40px);
  max-width: 100%;
  overflow: hidden;
  max-height: 100%;
}

.vertical-navigation-pictures {
  position: relative;
  height: calc(100% - 35px);
  width: calc(100% - 40px);
  max-width: 100%;
  overflow: hidden;
  max-height: 100%;
}

.vertical-navigation-pictures:hover {
  filter: brightness(70%);
}


/* DISCLAIMER BUTTON START */


.vertical-navigation-pictures-disclaimer {
  position: relative;
  height: calc(100% - 35px);
  width: calc(100% - 40px);
  max-width: 100%;
  overflow: hidden;
  max-height: 100%;
}


.disclaimer-container{
  width: 75%;
  cursor: pointer;
  border: none;
  padding: 0;
  background-color: transparent;
  
  /* TEXT FONT */
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  letter-spacing: 0.12px;
  position: relative;
  margin-top: auto;
  margin-bottom: 30px;
}



/* DISCLAIMER BUTTON END */


/* USER PROFILE START */

.profile-container{
  position: relative;
  margin-top: auto;
  margin-bottom: 60px;
  width: 70px;
}

.profile-image-container {
  position: relative;
  width: 100%;
  height: 10%; /* Set initial height to zero for aspect ratio calculation */
  padding-bottom: 80%; /* Maintain aspect ratio (height = width) */
  overflow: hidden;
  border-radius: 50%;
  margin: 0 auto; /* Center the container horizontally */
}

.profile-image {
  position: absolute;
  width: 100%; /* Make the image fill the container */
  height: 100%; /* Maintain aspect ratio */
  object-fit: cover; /* Ensure the image covers the container */
  display: block;
}

.profile-name-container{
  position: relative;
}

.profile-text{
  position: relative;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 1px;
}


.profile-disclaimer-container{
  position: relative;
  height: fit-content;
  width: 100%;
  border: 1px red solid;
  margin-bottom: 20px;


  /* TEXT STYLE */
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 1px;
}




/* USER PROFILE END */




.vertical-navigation-logout-button {
  position: absolute;
  z-index: 999;
  width: 50%;
  top: 48%;
  left: 50%;
  transform: translate(-50%, -50%) scale(1.5);
  color: rgba(255, 255, 255, 0);
  border: none;
  border-radius: 4px;
  cursor: pointer;
  animation: fadeInOut 0.7s ease-in-out;
}

@keyframes fadeInOut {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}


/* Add or modify existing styles as needed */

`, "",{"version":3,"sources":["webpack://./src/widgets/VerticalNavigationWidgets.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,sBAAsB;EACtB,iBAAiB;;;AAGnB;;AAEA;;;;;;;;;;;EAWE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,UAAU;EACV,6BAA6B;EAC7B,mBAAmB;;EAEnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,sBAAsB;AACxB;;;AAGA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;;AAGA,4BAA4B;;;AAG5B;EACE,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;;AAGA;EACE,UAAU;EACV,eAAe;EACf,YAAY;EACZ,UAAU;EACV,6BAA6B;;EAE7B,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;;;AAIA,0BAA0B;;;AAG1B,uBAAuB;;AAEvB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW,EAAE,4DAA4D;EACzE,mBAAmB,EAAE,2CAA2C;EAChE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc,EAAE,sCAAsC;AACxD;;AAEA;EACE,kBAAkB;EAClB,WAAW,EAAE,sCAAsC;EACnD,YAAY,EAAE,0BAA0B;EACxC,iBAAiB,EAAE,0CAA0C;EAC7D,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;;AAGA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;;;EAGnB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;;;;AAKA,qBAAqB;;;;;AAKrB;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,QAAQ;EACR,SAAS;EACT,2CAA2C;EAC3C,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;;AAGA,4CAA4C","sourcesContent":[".vertical-navigation {\r\n  position: fixed;\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: calc(100% - 80px);\r\n  top: 80px;\r\n  background-color: var(--gray-20);\r\n  width: 118px;\r\n  text-align: center;\r\n  align-items: center;\r\n  font-size: var(--inter-body-1-medium-size);\r\n  color: var(--gray-100);\r\n  padding-top: 40px;\r\n  \r\n\r\n}\r\n\r\n.vertical-navigation-first-button,\r\n.vertical-navigation-second-button,\r\n.vertical-navigation-third-button,\r\n.vertical-navigation-fourth-button,\r\n.vertical-navigation-fifth-button,\r\n.vertical-navigation-sixth-button,\r\n.vertical-navigation-seventh-button,\r\n.vertical-navigation-eigth-button,\r\n.vertical-navigation-settings-button,\r\n.vertical-navigation-contact-button,\r\n.vertical-navigation-profile-button {\r\n  position: relative;\r\n  width: 100%;\r\n  cursor: pointer;\r\n  border: none;\r\n  padding: 0;\r\n  background-color: transparent;\r\n  margin-bottom: 30px;\r\n  \r\n  /* TEXT FONT */\r\n  font-family: Inter;\r\n  font-size: 16px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 24px; /* 150% */\r\n  letter-spacing: 0.12px;\r\n}\r\n\r\n\r\n.vertical-navigation-pictures1 {\r\n  position: relative;\r\n  height: calc(100% - 35px);\r\n  width: calc(100% - 40px);\r\n  max-width: 100%;\r\n  overflow: hidden;\r\n  max-height: 100%;\r\n}\r\n\r\n.vertical-navigation-pictures {\r\n  position: relative;\r\n  height: calc(100% - 35px);\r\n  width: calc(100% - 40px);\r\n  max-width: 100%;\r\n  overflow: hidden;\r\n  max-height: 100%;\r\n}\r\n\r\n.vertical-navigation-pictures:hover {\r\n  filter: brightness(70%);\r\n}\r\n\r\n\r\n/* DISCLAIMER BUTTON START */\r\n\r\n\r\n.vertical-navigation-pictures-disclaimer {\r\n  position: relative;\r\n  height: calc(100% - 35px);\r\n  width: calc(100% - 40px);\r\n  max-width: 100%;\r\n  overflow: hidden;\r\n  max-height: 100%;\r\n}\r\n\r\n\r\n.disclaimer-container{\r\n  width: 75%;\r\n  cursor: pointer;\r\n  border: none;\r\n  padding: 0;\r\n  background-color: transparent;\r\n  \r\n  /* TEXT FONT */\r\n  font-family: Inter;\r\n  font-size: 16px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 24px; /* 150% */\r\n  letter-spacing: 0.12px;\r\n  position: relative;\r\n  margin-top: auto;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n\r\n\r\n/* DISCLAIMER BUTTON END */\r\n\r\n\r\n/* USER PROFILE START */\r\n\r\n.profile-container{\r\n  position: relative;\r\n  margin-top: auto;\r\n  margin-bottom: 60px;\r\n  width: 70px;\r\n}\r\n\r\n.profile-image-container {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 10%; /* Set initial height to zero for aspect ratio calculation */\r\n  padding-bottom: 80%; /* Maintain aspect ratio (height = width) */\r\n  overflow: hidden;\r\n  border-radius: 50%;\r\n  margin: 0 auto; /* Center the container horizontally */\r\n}\r\n\r\n.profile-image {\r\n  position: absolute;\r\n  width: 100%; /* Make the image fill the container */\r\n  height: 100%; /* Maintain aspect ratio */\r\n  object-fit: cover; /* Ensure the image covers the container */\r\n  display: block;\r\n}\r\n\r\n.profile-name-container{\r\n  position: relative;\r\n}\r\n\r\n.profile-text{\r\n  position: relative;\r\n  font-family: Inter;\r\n  font-size: 16px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 1px;\r\n}\r\n\r\n\r\n.profile-disclaimer-container{\r\n  position: relative;\r\n  height: fit-content;\r\n  width: 100%;\r\n  border: 1px red solid;\r\n  margin-bottom: 20px;\r\n\r\n\r\n  /* TEXT STYLE */\r\n  font-family: Inter;\r\n  font-size: 16px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 1px;\r\n}\r\n\r\n\r\n\r\n\r\n/* USER PROFILE END */\r\n\r\n\r\n\r\n\r\n.vertical-navigation-logout-button {\r\n  position: absolute;\r\n  z-index: 999;\r\n  width: 50%;\r\n  top: 48%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%) scale(1.5);\r\n  color: rgba(255, 255, 255, 0);\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  animation: fadeInOut 0.7s ease-in-out;\r\n}\r\n\r\n@keyframes fadeInOut {\r\n  0% {\r\n    opacity: 0;\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n\r\n/* Add or modify existing styles as needed */\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
